<template>
    <b-col sm="12">
        <b-row v-if="createType == null">
            <b-col sm="12" md="3" lg="2" v-for="ct in creationTypes" :key="ct.type">
                <b-card @click="() => { if (ct.available) { createType = ct.type } }">
                    <i :class="ct.icon"></i> {{ ct.label }}
                    <b-badge variant="warning" v-if="!ct.available" id="notAvailable"> ! </b-badge>
                    <b-tooltip target="notAvailable">{{ $t('functionalityNotAvailableOnAccount') }}</b-tooltip>
                </b-card>
            </b-col>
        </b-row>

        <b-col md="6">
            <b-card v-if="createType == 'component'">
                <b-form @submit="save">
                    <InputField name="name" :label="this.$t('name')" v-model="cName" @error="fieldError"
                        :description="`${$t('uniqueNameOfComponent')}`"
                        :rules="{ required: true, length: { min: 3, max: 25 } }" :errors="httpErrors['name']"
                        @input="format" />

                    <b-form-group
                        :label="this.$t('scope')"
                        label-for="scope"
                        :label-cols="12"
                        :description="this.$t('scopeDescription')"
                        :disabled="!canRemove"
                        :horizontal="true">
                            <v-select v-model="model.scope"  noDrop taggable/>
                    </b-form-group>

                    <b-form-group :label="this.$t('label')" label-for="label" :label-cols="12" :horizontal="true">
                        <Labeli18n v-model="label" />
                    </b-form-group>


                    <SelectField v-if="roles.length > 0" name="role" :description="this.$t('whichRole')"
                        :multiple="true" :label="this.$t('role')" v-model="model.roles" @error="fieldError"
                        :items="roles" :rules="{ required: false }" />

                    <SelectField v-if="workspaces.length > 0" :name="workspaces" :multiple="true"
                        :label="this.$t('workspaces')" v-model="spaces" @error="fieldError" :items="workspaces"
                        :rules="{ required: false }" />

                    <span v-else> {{ $t('noRoles') }} <router-link to="/admin/users/roles/create">{{ $t('here')
                            }}</router-link>.</span>

                    <div class="form-actions pull-right">
                        <b-button type="submit" variant="primary">{{ $t('saveChanges') }}</b-button>
                    </div>
                </b-form>
            </b-card>

            <b-card v-if="createType == 'app'">
                <b-form @submit="saveApp">
                    <InputField name="name" :label="this.$t('name')" v-model="cName" @error="fieldError"
                        :description="`${$t('uniqueNameOfApp')}`"
                        :rules="{ required: true, length: { min: 3, max: 25 } }" :errors="httpErrors['name']"
                        @input="format" />

                    <b-form-group :label="this.$t('label')" label-for="label" :label-cols="12" :horizontal="true">
                        <Labeli18n v-model="label" />
                    </b-form-group>

                    <SelectField v-if="workspaces.length > 0" name="workspaces" :multiple="true"
                        :label="this.$t('workspaces')" v-model="spaces" @error="fieldError" :items="workspaces"
                        :rules="{ required: false }" />

                    <span v-else> {{ $t('noRoles') }} <router-link to="/admin/users/roles/create">{{ $t('here')
                            }}</router-link>.</span>

                    <div class="form-actions pull-right">
                        <b-button type="submit" variant="primary">{{ $t('saveChanges') }}</b-button>
                    </div>
                </b-form>
            </b-card>

            <b-card v-if="createType == 'public-app'">
                <b-form @submit="savePublicApp">
                    <InputField name="name" :label="this.$t('name')" v-model="name" @error="fieldError"
                        :description="`${$t('uniqueNameOfApp')}`"
                        :rules="{ required: true, length: { min: 3, max: 25 } }" :errors="httpErrors['name']"
                        @input="format" />

                    <div class="form-actions pull-right">
                        <b-button type="submit" variant="primary">{{ $t('saveChanges') }}</b-button>
                    </div>
                </b-form>
            </b-card>

            <b-card v-if="createType == 'workflow'">
                <b-form @submit="saveWorkflow">
                    <InputField name="name" :label="this.$t('name')" v-model="name" @error="fieldError"
                        :description="`${$t('uniqueNameOfWorkflow')}`"
                        :rules="{ required: true, length: { min: 3, max: 25 } }" :errors="httpErrors['name']"
                        @input="format" />

                    <div class="form-actions pull-right">
                        <b-button type="submit" variant="primary">{{ $t('create') }}</b-button>
                    </div>
                </b-form>
            </b-card>
        </b-col>
    </b-col>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import _ from "lodash"
import Labeli18n from '../../components/form/Texti18n'
import vSelect from 'vue-select'

export default {
    name: "ComponentsCreate",
    components: {
        InputField: Input,
        SelectField: Select,
        cSwitch,
        Labeli18n,
        vSelect
    },
    data: function () {
        return {
            name: '',
            label: {
                locales: {

                }
            },
            httpErrors: [],
            errors: [],
            roles: [],
            is_external: false,
            spaces: [],
            createType: null,
            model: {
                name: '',
                roles: [],
                scope: null
            }
        }
    },

    methods: {
        format(v) {
            this.name = _.startCase(_.toLower(v)).toLowerCase()

            // clear http errors
            this.httpErrors = []
        },

        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk("Some fields are not valid!")

                return
            }

            this.$http.post("/v3/system/component/create", { 
                name: this.cName, 
                label: this.label, 
                roles: this.model.roles, 
                workspaces: this.spaces,
                scope: this.model.scope
            }).then((resp) => {
                if (resp == null) {
                    throw new Error("unexpected error")
                }

                this.$bvToast.toast("Component created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$store.dispatch("fetchComponents");

                let ref = resp.data.name
                if (resp.data.scope) {
                    ref = `${resp.data.scope}/${ref}`
                }

                this.$router.push({ path: "/admin/component/" + ref + "/settings" })
            }).catch(err => {
                if (err.response) {
                    if (err.response.status == 409) {
                        this.$bvModal.msgBoxOk("You exceeded your limit for maximum components on this project.")
                    }

                    if (err.response.status == 417) {
                        this.httpErrors = err.response.data.errors
                    }

                    this.$bvToast.toast(err.response.data.message, {
                        title: this.$t('error'),
                        variant: 'danger'
                    })
                    return
                }

                this.$bvToast.toast(this.$t('unexpectedError'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            })
        },

        saveApp(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk("Some fields are not valid!")

                return
            }

            this.$http.post("/v3/system/gateway/app-service/app", { name: this.cName, label: this.label, roles: this.model.roles, workspaces: this.spaces }).then((resp) => {
                this.$bvToast.toast("App created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$router.push({ path: "/admin/app/settings/" + resp.data.uuid })
            }).catch(err => {
                if (err.response.status == 417) {
                    this.httpErrors = err.response.data.errors
                }

                if (err.response.status == 409) {
                        this.$bvToast.toast(this.$t('maximumOfPublicAppsReached'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                    }
            })
        },

        savePublicApp(e) {
            e.preventDefault()
            let popup = this.$loadingPopup()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk("Some fields are not valid!")

                return
            }

            this.$http.post("/v3/system/gateway/app-service/public-app", { name: this.name }).then((resp) => {

                this.$bvToast.toast("Public app created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$router.push({ path: "/admin/public-app/" + resp.data.uuid })
            }).catch(err => {
                if (err.response) {
                    if (err.response.status == 417) {
                        this.httpErrors = err.response.data.errors
                    }

                    if (err.response.status == 409) {
                        this.$bvToast.toast(this.$t('maximumOfPublicAppsReached'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                    }
                }
            }).finally(() => {
                popup.hide()
            })
        },

        saveWorkflow(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk("Some fields are not valid!")

                return
            }

            this.$workflowApi.post("/workflow", { name: this.name }).then((resp) => {

                this.$bvToast.toast("Workflow created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$router.push({ path: "/admin/workflow/" + resp.data.uuid })
            }).catch(err => {
                if (err.response) {
                    if (err.response.status == 417) {
                        this.httpErrors = err.response.data.errors
                    }

                    if (err.response.status == 400) {
                        this.$bvModal.msgBoxOk(err.response.data.message)
                    }
                }

            })
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
    },
    computed: {
        workspaces() {
            return this.$store.getters.getCurrentProject.workspaces.map(w => {
                return {
                    text: w.name,
                    value: w.uuid
                }
            })
        },

        cName: {
            get() {
                return this.name.replaceAll(" ", "_")
            },

            set(val) {
                this.name = val.replaceAll(" ", "_")
            }
        },

        account() {
            return this.$store.getters.getAccount
        },

        creationTypes() {
            let types = [
                {
                    label: 'Public app',
                    type: 'public-app',
                    icon: 'bi bi-tablet',
                    available: this.account.public_apps > 0
                },
                {
                    label: 'Platform app',
                    type: 'app',
                    icon: 'bi bi-window',
                    available: this.account.platform_apps > 0
                },
                {
                    label: 'Component',
                    type: 'component',
                    icon: 'bi bi-boxes',
                    available: true
                },
                {
                    label: 'Workflow',
                    type: 'workflow',
                    icon: 'icon-share',
                    available: true
                }
            ]

            return types
        }
    },

    beforeCreate() {
        this.$store.dispatch("fetchRoles").then(data => {
            this.roles = data || []
            this.roles.map(el => {
                el.text = el.name
                el.value = el.uuid
            })
        }).catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }
        })
    },

    mounted() {
        if (this.$route.query.type) {
            this.createType = this.$route.query.type
        }
    }
}
</script>
